import { css } from "@emotion/react";
import { Spacing } from "@snapchat/snap-design-system";

export const canvasContainer = css`
    max-height: 480px;
    max-width: 640px;
    margin: ${Spacing.MD}px 0;
    > div {
        height: 100%;
    }
    div > video {
        height: 100%;
        width: 100%;
    }
    div > canvas {
        width: 100%;
        border-radius: 8px;
    }
`;

export const mobileContainerStyle = css`
    max-height: 640px;
    max-width: 480px;
`;

export const sourceLoading = css`
    height: 480px;
    width: 640px;
`;
